export const tableHeader = ['Title', 'Published Date', 'Action']
